import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20dramatic%20stage%20lighting%20film%20projector%20beam%20cutting%20through%20darkness%20luxurious%20golden%20decorative%20elements%20atmospheric%20and%20elegant%20warm%20tones%20professional%20wide-angle%20photography&width=1600&height=900&seq=hero-bg-cinema&orientation=landscape"
        alt="成全影院 - 高清画质流畅播放"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <div className="max-w-[800px] mx-auto">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading mb-4 leading-tight">
              成全影院
            </h1>
            <p className="text-base md:text-lg text-background-50/90 mb-3 max-w-[600px] mx-auto leading-relaxed">
              高清画质 · 流畅播放 · 不卡顿蓝光体验
            </p>
            <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-[500px] mx-auto">
              无广告干扰，免费在线观看电影电视剧全集，沉浸式追剧
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/dongzuo"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>立即观影
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 font-medium rounded-md text-sm transition-all border border-background-50/30 whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-6 left-0 right-0 flex justify-center">
        <div className="animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}